import { MatDialogRef } from '@angular/material/dialog';
import { UserUpdateModel, UserModel } from '../models';
import { UserOwnerType } from '../constants';
import { Role } from '../../../../../common/constants';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';

export class UserItemLoad {
  public static readonly type = '[UserItem] Load';

  constructor(public payload: string) {}
}

export class UserItemRolesLoad {
  public static readonly type = '[UserItem] All Roles Load';

  constructor(public payload: UserOwnerType) {}
}

export class UserEmailSearch {
  public static readonly type = '[UserItem] Email Search';

  constructor(public payload: string) {}
}

export class ActiveDirectoryEmailSearch {
  public static readonly type = '[UserItem] Active Directory Email Search';

  constructor(public payload: string) {}
}

export class UserItemApprove {
  public static readonly type = '[UserItem] Approve';

  constructor(public payload: { userId: string; role: Role[] }) {}
}

export class UserItemCreate {
  public static readonly type = '[UserItem] Create';

  constructor(public payload: UserUpdateModel) {}
}

export class UserItemUpdate {
  public static readonly type = '[UserItem] Update';

  constructor(public payload: UserModel) {}
}

export class UserItemResetPassword {
  public static readonly type = '[UserItem] Reset Password';

  constructor(public payload: { userId: string; dialog: MatDialogRef<ConfirmationDialogAfterClosedModel> }) {}
}

export class UserItemDelete {
  public static readonly type = '[UserItem] Delete';

  constructor(public payload: { dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>; userIds: number[] }) {}
}

export class UserItemInitialState {
  public static readonly type = '[UserItem] Set initial state';
}
